import { jsxs as r, jsx as e } from "react/jsx-runtime";
import { ExploreIllustration as t, BodyText as s } from "@placer-ui/components";
import o from "./index.es486.js";
import a from "classnames";
const i = `Draw a closed polygon on the map.
Press ‘esc’ to cancel`, n = () => /* @__PURE__ */ r(
  "div",
  {
    "data-testid": "create-poi-draw-mode",
    className: a(o.wrapper, o.drawModeIndicator),
    children: [
      /* @__PURE__ */ e(
        t,
        {
          size: {
            height: 224,
            width: 224
          }
        }
      ),
      /* @__PURE__ */ e(s, { children: i })
    ]
  }
);
export {
  n as CreatePoiDrawMode
};
//# sourceMappingURL=index.es443.js.map
